import { useState } from 'react';
import Grid from './Grid';
import SearchCriteria from './SearchCriteria';

const Layout = (props: any) => {
    const [showSearchCriteria, setShowSearchCriteria] = useState(true);

    const handleToggleSearchCriteria = () => {
        setShowSearchCriteria(!showSearchCriteria);
    };

    return (
        <div>
            <div className="main flex-1">
                <section className="updateadditionalinformation">
                    <div className="container-fluid px-3 px-lg-4">
                        <div className="row">
                            <div className="col-md-12 mb-4">
                                <div className="white-block white-block-notopborderradius p-0 h-100">
                                    <div className="p-4 p-md-5">
                                        <div className="alumni_statistics">
                                            <h2 className="font-26 font-600 mb-0 pb-4">School Api Key</h2>

                                            <div className="ActiveListings_present">
                                                <div className="d-flex flex-wrap justify-content-between align-items-start align-items-md-center mb-2 filterSearch">
                                                    <div className="d-flex flex-wrap flex-1 mb-0 justify-content-start">
                                                        <button
                                                            className="btn-grpfiter me-3"
                                                            type="button"
                                                            onClick={handleToggleSearchCriteria}>
                                                            <i className="icon-filter font-13 me-2"></i>
                                                            {showSearchCriteria ? `Hide Filters` : `Show Filters`}
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* Search Criteria */}
                                                {showSearchCriteria && <SearchCriteria />}

                                                {/* <div className="d-flex flex-wrap align-items-center mb-3 w-100 justify-content-between mailerLinks-parent">
                                                    <div className="d-flex flex-wrap align-items-center flex-1 mailerLinks my-2">
                                                        <div className="d-flex justify-content-start align-items-center customselect_parnt">
                                                            <select
                                                                name="complete Class 12"
                                                                aria-label="Default select example"
                                                                className="form-select w-120">
                                                                <option value="Action">Show 20</option>
                                                                <option value="Mark as Unseen">20</option>
                                                                <option value="Mark as Seen">30</option>
                                                                <option value="Mark Important">40</option>
                                                                <option value="Unmark Important">50</option>
                                                                <option value="Delete">60</option>
                                                                <option value="Ignore">70</option>
                                                                <option value="Block">80</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-wrap align-items-center justify-content-end">
                                                        <div className="d-flex justify-content-start align-items-center customselect_parnt me-auto mobile-100 mb-3 mb-sm-0"></div>
                                                        <h3 className="font-14 font-500 mb-0 me-2">Showing 1-20 of 220 records</h3>
                                                        <div className="d-flex flex-wrap custom-btn">
                                                            <a className="btn-prev icon-left-arrow" href=""></a>
                                                            <a className="btn-prev icon-right-arrow" href=""></a>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                {/* Grid */}
                                                <Grid />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Layout;
